import { cx } from '@linaria/core';
import { noop } from 'utils/fp';
import { useModalActions } from 'components/ModalManager/Context';
import {
  navBarDropdown,
  navLink__Active,
  navLink__Radius,
  btnNoBorder,
  notificationModalStyles,
  notificationModalWrapperStyles,
  avatarPadding,
  avatarPopover,
} from 'components/Navbar/Navbar.styles';
import { useAuthState } from 'modules/Auth/AuthContext';
import { useBreakpoint } from 'utils/responsive';
import { breakpoints } from 'styles/utils';
import { useCompositePopover } from 'hooks/useCompositePopover';
import { Popover, PopoverAction } from 'components/Popover';
import { Avatar } from 'components/Avatar';
import { DesktopMenuItems, MobileMenuItems, MobileMenuItemsProps } from './MenuPopover';

type MenuButtonProps = Pick<MobileMenuItemsProps, 'onLogout' | 'canCreateApp' | 'handleCreateApp'>;

const MENU_MODAL_ID = 'menu_modal_id';

export function MenuButton(props: MenuButtonProps) {
  const { openModal, closeModal } = useModalActions();
  const { authData } = useAuthState();
  const isTabletViewport = useBreakpoint(breakpoints.down('bigtab'));
  const userId = authData?.user_id || '';

  const closeMenuModal = () => closeModal({ id: MENU_MODAL_ID });

  const openMenuModal = () =>
    openModal({
      id: MENU_MODAL_ID,
      title: '',
      makeActions: noop,
      closeOnBackdropClick: true,
      contentWrapperClassName: notificationModalStyles,
      className: notificationModalWrapperStyles,
      content: (
        <MobileMenuItems
          closePopup={closeMenuModal}
          canCreateApp={props.canCreateApp}
          handleCreateApp={props.handleCreateApp}
          onLogout={props.onLogout}
        />
      ),
    });

  const { popoverState, togglePopoverOrModal, visible, closePopoverOrModal } = useCompositePopover({
    breakpointWidth: 800,
    modal: {
      id: MENU_MODAL_ID,
      open: openMenuModal,
      close: closeMenuModal,
    },
  });

  return (
    <>
      <PopoverAction
        as="button"
        popover={popoverState}
        key="menu-popover-desktop"
        data-testid="navbar-menu-btn"
        onClick={togglePopoverOrModal}
        className={cx(btnNoBorder, navBarDropdown, navLink__Active, navLink__Radius, avatarPadding, visible && 'active')}
        style={{ maxHeight: 'max-content' }}
      >
        <Avatar alt="user avatar" userId={userId} size={isTabletViewport ? 32 : 40} />
      </PopoverAction>

      <Popover aria-label="Help" data-testid="navbar-menu-popover" popover={popoverState} className={avatarPopover}>
        <DesktopMenuItems onLogout={props.onLogout} closePopup={closePopoverOrModal} />
      </Popover>
    </>
  );
}
